import Button from '@material-ui/core/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './button-finish.scss';

export interface ButtonFinishProps {
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

export const ButtonFinish = (props: ButtonFinishProps): JSX.Element => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (!(props.isLoading || props.disabled)) {
            props.onClick();
        }
    };

    return (
        <div className="button__style--fourth">
            <Button variant="contained" onClick={handleClick} disabled={props.disabled || props.isLoading}>
                {t('accept-invite.buttons.finish').toUpperCase()}
            </Button>
        </div>
    );
};

export default ButtonFinish;
